import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Toolbar,
  ToolbarLeft,
  ToolbarRight,
} from 'pages/Common/styles/ControlBar';
import { SettingsButton } from 'pages/Common/components/CustomObjectSettingsButton';
import { StyledToolbarWrapper } from './styles';
import {
  getBusinessClientObject,
  getContactsAccess,
  getCustomObjectSettinsAccess,
} from 'store/authentication/selectors';
import { getContactSettingOptions } from './helpers';
import { useContext, useMemo } from 'react';
import ViewVariant from 'components/ViewVariant';
import { VIEW_VARIANTS } from 'components/ViewVariant/types';
import GroupSelector from 'components/DashboardGrid/GroupSelector';
import { PluginContext } from 'ts-components/Plugins/context';
import { useAIFeatures, AI_FEATURE_CONFIG_KEYS } from 'hooks/useAIFeatures';
import { MarketPlacePluginApiName } from 'pages/Marketplace/types';

const ControlBar = ({
  onChoseSettings,
  disabled,
  viewVariant,
  isChartView,
  chartGroupConfigProps,
  ...props
}) => {
  const { t } = useTranslation();
  const { object_settings } = useSelector(getContactsAccess);

  const { objectSettingsMenuItems } = useContext(PluginContext);
  const { aiFeaturesEnabled: chatEnabled } = useAIFeatures(
    AI_FEATURE_CONFIG_KEYS.chat
  );
  const { aiFeaturesEnabled: customObjectEditorEnabled } = useAIFeatures(
    AI_FEATURE_CONFIG_KEYS.custom_object_editor
  );

  const settingsOptions = useMemo(() => {
    // Filter out the AI agent menu item if custom_object_editor is disabled
    const filteredMenuItems =
      chatEnabled && customObjectEditorEnabled
        ? objectSettingsMenuItems
        : objectSettingsMenuItems.filter(
            (item) => item.plugin_api_name !== MarketPlacePluginApiName.KizenAI
          );
    return getContactSettingOptions(t, object_settings, filteredMenuItems);
  }, [
    t,
    object_settings,
    objectSettingsMenuItems,
    chatEnabled,
    customObjectEditorEnabled,
  ]);
  const { contacts } = useSelector(getCustomObjectSettinsAccess);

  const clientObject = useSelector(getBusinessClientObject);

  return (
    <StyledToolbarWrapper className="toolbar-wrapper" {...props}>
      <Toolbar className="toolbar">
        <ToolbarLeft></ToolbarLeft>
        <ToolbarRight>
          {isChartView ? <GroupSelector {...chartGroupConfigProps} /> : null}
          <ViewVariant hide={VIEW_VARIANTS.BOARD} />
          {contacts.edit ? (
            <SettingsButton
              options={settingsOptions}
              onChange={onChoseSettings}
              variant="text"
              color="blue"
              disabled={disabled}
              customObjectId={clientObject.id}
            />
          ) : null}
        </ToolbarRight>
      </Toolbar>
    </StyledToolbarWrapper>
  );
};

export default ControlBar;
